<template>
  <div v-if="loading" class="mt-3 font-xl text-muted">
    <i class="fal fa-spinner fa-spin" />
  </div>
  <div v-else class="animated">
    <b-row class="my-4">
      <b-col
        v-for="(row, rowIndex) in formatted_rows"
        :key="rowIndex"
        sm="12"
        md="6"
        class="pr-0"
      >
        <b-row class="pr-3">
          <b-col v-if="row.label" class="pr-0">
            <label class="font-weight-bold">
              {{ row.label }}
            </label>
          </b-col>
          <b-col class="pr-0">
            <span>{{ row.value }}</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <v-client-table
      id="sample-list-table"
      :columns="columns"
      :data="sample_results.map(i => i.attributes)"
      :options="options"
      :theme="theme"
      class="w-100"
    >
      <span slot="analyte" slot-scope="{ row }">
        {{ row.analyte }}
      </span>

      <span slot="result" slot-scope="{ row }">
        <a :href="`#/result-manager/${row.lims_id}`">
          {{ row.value }}
        </a>
      </span>
    </v-client-table>
  </div>
</template>

<script>
import Vue from 'vue'
import { ClientTable } from 'vue-tables-2'
import SampleResultCollection from '@/collections/result/SampleResultCollection'

Vue.use(ClientTable)

export default {
  name: 'ResultSampleAnalyteTable',
  components: {
    ClientTable
  },
  props: {
    sample: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      columns: [
        'analyte',
        'result'
      ],
      options: {
        filterable: []
      },
      theme: 'bootstrap4',

      loading: true,
      sample_results: null
    }
  },
  computed: {
    rows () {
      return [
        {
          label: "Depth Start",
          value: this.sample.depth_start
        },
        {
          label: "Depth End",
          value: this.sample.depth_end
        }
      ]
    },
    formatted_rows() {
      const rows = [];

      for (let i = 0; i < this.rows.length; i++) {
        if (this.rows[i].value) {
          const row = this.rows[i];

          !row.slot &&
            (row.slot = row.label ? row.label.replace(/\s+/g, "") : `row-${i}`);
          rows.push(row);
        }
      }

      return rows;
    },
  },
  created () {
    if (this.sample && this.sample.id) {
      this.fetchSampleResults()
    }
  },
  methods: {
    fetchSampleResults () {
      const sample_results = new SampleResultCollection()
      const filter = sample_results.getFilter()

      filter.filterEquals('sample_id', this.sample.id)

      sample_results.fetch().then(() => {
        this.sample_results = sample_results.models
        this.loading = false
      })
    }
  }
}
</script>
